// extracted by mini-css-extract-plugin
export default {"pageLayout":"UserJobProspects-module__pageLayout___i3JfH"};